enum events {
  SPM_TS = 'spm-ts',
  REFRESH_TOKEN = 'refresh-token',
  OPEN_WINDOW = 'openWindow',
  INIT_COMPLETED = 'init-completed',
  TRACK_EVENT = 'track-event',
  SEND_FEEDBACK = 'send-feedback',
  CONTENT_AI_GENERATE = 'content-ai-generate',
  CONTENT_AI_VARIATION_SHOW = 'content-ai-variations-show',
  CONTENT_AI_ACTION_GENERATE = 'content-ai-quick-action-generate',
  IMAGE_AI_GENERATE = 'image-ai-generate',
  IMAGE_AI_VARIATION_SHOW = 'image-ai-variations-show',
  EDIT_EMAIL_TEMPLATE = 'edit-email-template',
  IMAGE_EDITOR_OPEN = 'social_planner--image_editor--open',
  CHILD_IMAGE_EDITOR_EDITED = 'social_planner--image_editor--edited--image',
  CHILD_REFRESH_EMAIL_TEMPLATE = 'refresh-email-template',
  CHILD_CHANGE_ROUTE = 'change-route',
  CHILD_ADD_CONTENT_AI_IMAGE = 'add-content-ai-image',
  CHILD_REFRESH_CONTENT_AI = 'refresh-content-ai',
  CHILD_UPDATE_TOKEN = 'updated-token',
  HIDE_TOP_BAR = 'social_planner--hide_top_bar',
  INITIALISED_PLANNER = "social_planner--initialised_planner",
  ROUTE_CHANGE = 'social_planner--route_change',
  CLOSE_TEMPLATE_LIBRARY = 'social_planner--close_template_library',
  OPEN_TEMPLATE_LIBRARY = 'social_planner--open-template-library',
  OPEN_CREATE_TEMPLATE = 'social_planner--open-upload-template-modal',
  SET_PREVIOUS_DASHBOARD_TAB = 'social_planner--set-previous-dashboard-tab',
  OPEN_SEND_FEEDBACK = 'social_planner--send-feedback',
  REFRESH_TEMPLATE_LIBRARY_TAB = 'social_planner--refresh-template-library-tab',
}

export default events